import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, ReorderIcon, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { MyWorkProjectsReorderDialog } from "~/components/MyWork/MyTasks/MyWorkProjectsReorderDialog";
export const MyWorkProjectsReorderControl = ({ className }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const onClose = useCallback(() => setOpen(false), []);
  const onOpen = useCallback(() => setOpen(true), []);
  return (
    <>
      <Tooltip title={t("Reorder Projects")}>
        <IconButton
          variant="text gray"
          className={className}
          onClick={onOpen}
        >
          <ReorderIcon />
        </IconButton>
      </Tooltip>
      {open ? (
        <MyWorkProjectsReorderDialog
          open={open}
          onClose={onClose}
        />
      ) : null}
    </>
  );
};

MyWorkProjectsReorderControl.propTypes = {
  groupedBy: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

MyWorkProjectsReorderControl.defaultProps = {
  groupedBy: "project",
  onChange: () => null,
};
